// Global FIFO queue that limits how many audio files download at once.
// Each task.run() returns a promise that settles when that file has finished
// loading (or failed); the freed slot then pulls the next task.
class AudioLoadQueue {
  constructor(concurrency = 2) {
    this.concurrency = concurrency
    this.queue = []
    this.active = 0
  }

  enqueue(task) {
    this.queue.push(task)
    this.pump()
  }

  remove(task) {
    const index = this.queue.indexOf(task)
    if (index !== -1) this.queue.splice(index, 1)
  }

  pump() {
    while (this.active < this.concurrency && this.queue.length > 0) {
      const task = this.queue.shift()
      this.active += 1
      Promise.resolve()
        .then(() => task.run())
        .catch(() => {})
        .finally(() => {
          this.active -= 1
          this.pump()
        })
    }
  }
}

export const audioLoadQueue = new AudioLoadQueue(2)
